import { qltClient } from '../clients';
import { Repository } from '../core/repository';
import type { Id, QltClassNote } from '../types';

export type ClassNoteUpsertPayload = Omit<QltClassNote, 'id' | '_id' | 'createdAt' | 'updatedAt'>;

export interface ParentNoticeRequest {
  type: 'homework' | 'notification';
  title: string;
  content: string;
  shortContent: string;
}

const repository = Repository<QltClassNote>(qltClient, '/class-notes');

export const ClassNoteRepository = {
  ...repository,
  // POST is an idempotent upsert when class + index + date are present.
  upsert: (data: ClassNoteUpsertPayload) => repository.create<QltClassNote>(data),
  // lms-api takes the class from the note and pushes to its parents (post.afterCreate, production only).
  parentNotice: (id: Id, notice: ParentNoticeRequest) =>
    qltClient
      .post(`/class-notes/${encodeURIComponent(String(id))}/parent-notice`, notice)
      .then((res) => res.data as { id?: Id }),
};

export default ClassNoteRepository;
